// import React, { useState, useEffect } from "react";
// import { Box, Typography, Container, Autocomplete, CircularProgress, Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { DecorativeCorner } from "../../common/DecorativeCorner";
// import { styles } from "../../styles/styles";
// import {
// 	StyledFormControl,
// 	FormContainer,
// 	StyledButton,
// 	FormGrid,
// 	StyledTextField,
// } from "../../common/FormStyles";
// import { InputLabel, MenuItem, Select } from "@mui/material";
// import {
// 	getLookingForList,
// 	getReligionsList,
// 	getCastesList,
// 	getEducationList,
// 	getProfessionList,
// 	updatePartnerDetails,
// 	getFamilyStatusList,
// 	getProfileDetails,
// } from "../../../services/operations/userOperations";
// import CustomAlert from "../../common/CustomAlert";
// const heightOptions = [
// 	{ id: 137, name: `4'6" (137 cm)` },
// 	{ id: 140, name: `4'7" (140 cm)` },
// 	{ id: 142, name: `4'8" (142 cm)` },
// 	{ id: 145, name: `4'9" (145 cm)` },
// 	{ id: 147, name: `4'10" (147 cm)` },
// 	{ id: 150, name: `4'11" (150 cm)` },
// 	{ id: 152, name: `5'0" (152 cm)` },
// 	{ id: 155, name: `5'1" (155 cm)` },
// 	{ id: 157, name: `5'2" (157 cm)` },
// 	{ id: 160, name: `5'3" (160 cm)` },
// 	{ id: 163, name: `5'4" (163 cm)` },
// 	{ id: 165, name: `5'5" (165 cm)` },
// 	{ id: 168, name: `5'6" (168 cm)` },
// 	{ id: 170, name: `5'7" (170 cm)` },
// 	{ id: 173, name: `5'8" (173 cm)` },
// 	{ id: 175, name: `5'9" (175 cm)` },
// 	{ id: 178, name: `5'10" (178 cm)` },
// 	{ id: 180, name: `5'11" (180 cm)` },
// 	{ id: 183, name: `6'0" (183 cm)` },
// 	{ id: 185, name: `6'1" (185 cm)` },
// 	{ id: 188, name: `6'2" (188 cm)` },
// 	{ id: 191, name: `6'3" (191 cm)` },
// 	{ id: 193, name: `6'4" (193 cm)` },
// 	{ id: 196, name: `6'5" (196 cm)` },
// 	{ id: 198, name: `6'6" (198 cm)` },
// 	{ id: 201, name: `6'7" (201 cm)` },
// 	{ id: 203, name: `6'8" (203 cm)` },
// 	{ id: 206, name: `6'9" (206 cm)` },
// 	{ id: 208, name: `6'10" (208 cm)` },
// ];
// const maritalStatuses = [
// 	{ id: "Single", name: "Un Married" },
// 	// { id: "Married", name: "Married" },
// 	{ id: "Divorced", name: "Divorced" },
// 	{ id: "WaitingForDivorce", name: "Waiting for Divorce" },
// 	{ id: "Widowed", name: "Widowed" },
// ];


// const workingLocationOptions = [{ id: 1, name: "India" }, { id: 2, name: "Abroad" }, { id: 3, name: "Doesn't Matter" }]
// const PartnerPreferencesForm = (props) => {
// 	let { type } = props
// 	const navigate = useNavigate();
// 	const [lookingForList, setLookingForList] = useState([]);
// 	// const [selectedLookingFor, setSelectedLookingFor] = useState(null);
// 	const [religions, setReligions] = useState([]);
// 	// const [selectedReligion, setSelectedReligion] = useState(null);
// 	const [castes, setCastes] = useState([]);
// 	const [selectedCaste, setSelectedCaste] = useState([]);
// 	const [selectedLookingFor, setSelectedLookingFor] = useState([])
// 	const [educationList, setEducationList] = useState([]);
// 	const [selectedEducation, setSelectedEducation] = useState([]);
// 	const [professions, setProfessions] = useState([]);
// 	const [selectedProfession, setSelectedProfession] = useState([]);

// 	const [alert, setAlert] = useState({
// 		open: false,
// 		message: "",
// 		severity: "success",
// 	});

// 	const [selectedFamilyStatus, setSelectedFamilyStatus] = useState("");
// 	const [familyStatusList, setFamilyStatusList] = useState([]);
// 	const [ageFrom, setAgeFrom] = useState("");
// 	const [anualIncomeFrom, setAnualIncomeFrom] = useState("");
// 	const [ageTo, setAgeTo] = useState("");
// 	const [heightFrom, setHeightFrom] = useState(null);
// 	const [heightTo, setHeightTo] = useState(null);
// 	const [interCasteMarriage, setInterCasteMarriage] = useState("");
// 	const [convertedCaste, setConvertedCaste] = useState("");
// 	const [noCasteBar, setNoCasteBar] = useState("");
// 	const [kujaDosham, setKujaDosham] = useState("");
// 	const [complexion, setComplexion] = useState("");
// 	const [smoke, setSmoke] = useState("");
// 	const [drink, setDrink] = useState("");
// 	const [workingLocation, setWorkingLocation] = useState([]);
// 	const [passport, setPassport] = useState("");
// 	let userType = sessionStorage.getItem("userType")
// 	let token
// 	if(userType){
// 		token = sessionStorage.getItem("token");
// 	}else{
// 		 token = localStorage.getItem("token");
// 	}
// 	// Add mapping for complexion values
// 	const COMPLEXION_MAP = {
// 		fair: 1,
// 		medium: 2,
// 		dark: 3,
// 		doesnt_matter: 4,
// 	};

// 	const [profileData, setProfileData] = useState(null);
// 	useEffect(() => {
// 		const fetchProfile = async () => {
// 			try {
// 				const response = await getProfileDetails();
// 				if (response.status) {
// 					setProfileData(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching profile details:", error);
// 			}
// 		};

// 		fetchProfile();
// 	}, [type]);
// 	useEffect(() => {
// 		const fetchLookingFor = async () => {
// 			try {
// 				const response = await getLookingForList();
// 				if (response.status) {
// 					setLookingForList(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching looking for list:", error);
// 			}
// 		};

// 		const fetchReligions = async () => {
// 			try {
// 				const response = await getReligionsList();
// 				if (response.status) {
// 					setReligions(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching religions:", error);
// 			}
// 		};

// 		const fetchCastes = async () => {
// 			try {
// 				const response = await getCastesList();
// 				if (response.status) {
// 					setCastes(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching castes:", error);
// 			}
// 		};

// 		const fetchEducation = async () => {
// 			try {
// 				const response = await getEducationList();
// 				if (response.status) {
// 					setEducationList(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching education list:", error);
// 			}
// 		};

// 		const fetchProfessions = async () => {
// 			try {
// 				const response = await getProfessionList();
// 				if (response.status) {
// 					setProfessions(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching professions:", error);
// 			}
// 		};

// 		const fetchFamilyStatusList = async () => {
// 			try {
// 				const response = await getFamilyStatusList();
// 				if (response.status) {
// 					setFamilyStatusList(response.data);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching family status list:", error);
// 			}
// 		};

// 		if (token) {
// 			fetchLookingFor();
// 			fetchReligions();
// 			fetchCastes();
// 			fetchEducation();
// 			fetchProfessions();
// 			fetchFamilyStatusList();
// 		}
// 	}, []);

// 	useEffect(() => {
// 		const fetchAndPopulateData = async () => {
// 			try {
// 				const response = await getProfileDetails();
// 				if (response.status && response.data?.partnerDetails) {
// 					const data = response.data.partnerDetails;

// 					// Basic preferences
// 					// setSelectedLookingFor(
// 					// 	lookingForList.find((l) => l.id === data.lookingFor) || null
// 					// );
// 					setSelectedFamilyStatus(
// 						familyStatusList.find((fs) => fs.id === data?.familyStatus) || null
// 					);
// 					setInterCasteMarriage(data?.readyForInterCasteMarriage || data?.readyForInterCasteMarriage == 0 ? `${data?.readyForInterCasteMarriage}` : null)
// 					setConvertedCaste(
// 						data?.lookingForSameConvertedCast || data?.lookingForSameConvertedCast == 0 ? `${data?.lookingForSameConvertedCast}` : null
// 					);
// 					// Age and height preferences
// 					setAgeFrom(data?.ageFrom?.toString() || "");
// 					setAgeTo(data?.ageTo?.toString() || "");
// 					// setHeightFrom(data.heightFrom?.toString() || "");
// 					// setHeightTo(data.heightTo?.toString() || "");

// 					// Religion and caste preferences
// 					// setSelectedReligion(
// 					// 	religions.find((r) => r.id === data.religion) || null
// 					// );
// 					if (data?.preferCastes) {
// 						const skillIds =
// 							typeof data?.preferCastes === "string"
// 								? data?.preferCastes.split(",").map(Number)
// 								: Array.isArray(data?.preferCastes)
// 									? data?.preferCastes
// 									: [];

// 						// Find matching skills from SKILLS_LIST
// 						const selectedSkills = castes.filter((cast) =>
// 							skillIds.includes(cast.id)
// 						);

// 						setSelectedCaste(selectedSkills);
// 					}
// 					// setSelectedCaste(
// 					// 	[castes.find((c) => c.id === data.caste)].filter(Boolean)
// 					// );

// 					// Marriage preferences
// 					// setInterCasteMarriage(
// 					// 	data.readyForInterCasteMarriage === 1 ? "yes" : "no"
// 					// );
// 					// setConvertedCaste(
// 					// 	data.lookingForSameConvertedCast === 1 ? "yes" : "no"
// 					// );
// 					// Lifestyle preferences

// 					setKujaDosham(data?.khujaDhosham || data?.khujaDhosham == 0 ? `${data?.khujaDhosham}` : null)
// 					// setComplexion(
// 					// 	Object.keys(COMPLEXION_MAP).find(
// 					// 		(key) => COMPLEXION_MAP[key] === data.complexion
// 					// 	) || ""
// 					// );
// 					setSmoke(data?.smoke || data?.smoke == 0 ? `${data?.smoke}` : null);
// 					setDrink(data?.drink || data?.drink == 0 ? `${data?.drink}` : null);
// 					setWorkingLocation(data?.workingLocation || data?.workingLocation == 0 ? `${data?.workingLocation}` : null)
// 					// Education and profession

// 					if (data?.preferEducation) {
// 						const educatonIds =
// 							typeof data?.preferEducation === "string"
// 								? data?.preferEducation.split(",").map(Number)
// 								: Array.isArray(data?.preferEducation)
// 									? data?.preferEducation
// 									: [];

// 						// Find matching skills from SKILLS_LIST
// 						const education = educationList.filter((cast) =>
// 							educatonIds.includes(cast.id)
// 						);

// 						setSelectedEducation(education);
// 					}

// 					if (data.preferProfession) {
// 						const professionIds =
// 							typeof data?.preferProfession === "string"
// 								? data?.preferProfession.split(",").map(Number)
// 								: Array.isArray(data?.preferProfession)
// 									? data?.preferProfession
// 									: [];

// 						// Find matching skills from SKILLS_LIST
// 						const newPro = professions.filter((cast) =>
// 							professionIds.includes(cast.id)
// 						);

// 						setSelectedProfession(newPro);
// 					}
// 					// setSelectedEducation(
// 					// 	[educationList.find((e) => e.id === data.education)].filter(Boolean)
// 					// );
// 					// setSelectedProfession(
// 					// 	[professions.find((p) => p.id === data.profession)].filter(Boolean)
// 					// );

// 					// Other preferences
// 					setPassport(data?.passport || data?.passport == 0 ? `${data?.passport}` : null);
// 				}
// 			} catch (error) {
// 				console.error("Error fetching profile data:", error);
// 			}
// 		};

// 		if (
// 			token &&
// 			lookingForList.length &&
// 			religions.length &&
// 			castes.length
// 		) {
// 			fetchAndPopulateData();
// 		}
// 	}, [lookingForList, religions, castes, educationList, professions, type]);

// 	const handleContinue = async () => {
// 		try {
// 			// const payload = {
// 			// 	lookingFor: selectedLookingFor?.id || null,
// 			// 	ageFrom: Number(ageFrom) || null,
// 			// 	ageTo: Number(ageTo) || null,
// 			// 	heightFrom: String(heightFrom) || null,
// 			// 	heightTo: String(heightTo) || null,
// 			// 	familyStatus: Number(selectedFamilyStatus?.id) || null,
// 			// 	readyForInterCasteMarriage: interCasteMarriage === "yes" ? 1 : 0,
// 			// 	marryInterReligionParentsChild: convertedCaste === "yes" ? 1 : 0,
// 			// 	marryInterCasteParentsChild: kujaDosham === "yes" ? 1 : 0,
// 			// 	caste: Number(selectedCaste[0]?.id) || null, // Ensure caste is a single number
// 			// 	subCaste: null, // Add logic to handle subCaste if applicable
// 			// 	khujaDhosham: kujaDosham === "yes" ? 1 : 0,
// 			// 	complexion: COMPLEXION_MAP[complexion] || null,
// 			// 	smoke: smoke === "yes" ? 1 : 0,
// 			// 	drink: drink === "yes" ? 1 : 0,
// 			// 	education: Number(selectedEducation[0]?.id) || null, // Ensure education is a single number
// 			// 	profession: Number(selectedProfession[0]?.id) || null, // Ensure profession is a single number
// 			// 	Passport: passport === "yes" ? 1 : 0,
// 			// 	uplaodPicture: "string", // Placeholder for picture upload
// 			// };



// 			let newPayload = {
// 				"ageFrom": Number(ageFrom) || null,
// 				"ageTo": Number(ageTo) || null,
// 				"heightFrom": heightFrom ? Number(heightFrom?.id) : null,
// 				"heightTo": heightTo ? Number(heightTo?.id) : null,
// 				"familyStatus_id": Number(selectedFamilyStatus?.id) || null,
// 				"readyForInterCasteMarriage": Number(interCasteMarriage) || null,
// 				"lookingForSameConvertedCast": Number(convertedCaste) || null,
// 				"preferCastes": selectedCaste ? selectedCaste.map((each) => each.id) : null,
// 				"khujaDhosham": kujaDosham !== undefined && kujaDosham !== null ? Number(kujaDosham) : null,
// 				"complexion": complexion ? Number(complexion) : null,
// 				"smoke": smoke === "" || smoke === undefined ? null : Number(smoke),
// 				"drink": drink === "" || drink === undefined ? null : Number(drink),
// 				"preferEducation": selectedEducation ? selectedEducation.map((each) => each.id) : null,
// 				"preferProfession": selectedProfession ? selectedProfession.map((each) => each.id) : null,
// 				"passport": passport || passport == 0 ? Number(passport) : null,
// 				"preferWorkingLocation": workingLocation ? workingLocation.map((each) => each.id) : null,
// 				// "religion" : selectedReligion ? selectedReligion?.id : null,
// 				"anualIncomeFrom": anualIncomeFrom ? Number(anualIncomeFrom) : 0,
// 				lookingFor: selectedLookingFor ? selectedLookingFor.map((each) => each.name) : null,
// 				noCasteBar: noCasteBar ? Number(noCasteBar) : null
// 			}

// 			const response = await updatePartnerDetails(newPayload);

// 			if (!response.status) {
// 				setAlert({
// 					open: true,
// 					message: response.message,
// 					severity: "error",
// 				});
// 				return;
// 			}

// 			setAlert({
// 				open: true,
// 				message: "Partner preferences updated successfully",
// 				severity: "success",
// 			});
// 			if (type != "edit") {
// 				setTimeout(() => {
// 					navigate("/profile/review");
// 				}, 1000);
// 			}

// 		} catch (error) {
// 			setAlert({
// 				open: true,
// 				message: error.message || "Failed to update partner preferences",
// 				severity: "error",
// 			});
// 		}
// 	};

// 	const handleFamilyStatusChange = (event) => {
// 		// Get the selected family status object from the list
// 		const selectedStatus = familyStatusList.find(
// 			(status) => status.id === event.target.value
// 		);
// 		setSelectedFamilyStatus(selectedStatus);
// 	};

// 	const handleInterCasteMarriageChange = (event) => {
// 		setInterCasteMarriage(event.target.value);
// 	};

// 	const handleConvertedCasteChange = (event) => {
// 		setConvertedCaste(event.target.value);
// 	};

// 	const handleKujaDoshamChange = (event) => {
// 		setKujaDosham(event.target.value);
// 	};

// 	const handleComplexionChange = (event) => {
// 		setComplexion(event.target.value);
// 	};

// 	const handleSmokeChange = (event) => {
// 		setSmoke(event.target.value);
// 	};

// 	const handleDrinkChange = (event) => {
// 		setDrink(event.target.value);
// 	};

// 	const handleWorkingLocationChange = (event) => {
// 		setWorkingLocation(event.target.value);
// 	};

// 	const handlePassportChange = (event) => {
// 		setPassport(event.target.value);
// 	};
// 	useEffect(() => {
// 		if (profileData?.partnerDetails) {
// 			const selectedHeightFrom = heightOptions.find(
// 				(item) => item.id === profileData.partnerDetails.heightFrom
// 			);
// 			const selectedHeightTo = heightOptions.find(
// 				(item) => item.id === profileData.partnerDetails.heightTo
// 			);

// 			setHeightFrom(selectedHeightFrom || null);
// 			setHeightTo(selectedHeightTo || null);
// 		}
// 		if (profileData?.partnerDetails?.lookingFor && profileData?.partnerDetails?.lookingFor.length > 0) {
// 			const selectedCasteFor = maritalStatuses.filter((look) =>
// 				profileData?.partnerDetails?.lookingFor.includes(look.name.toString())
// 			);
// 			setSelectedLookingFor(selectedCasteFor);
// 		}

// 		if (profileData?.partnerDetails?.noCastBar || profileData?.partnerDetails?.noCastBar == 0) {
// 			setNoCasteBar(profileData.partnerDetails.noCastBar);
// 		}
// 		if (profileData?.partnerDetails) {
// 			setPassport(profileData.partnerDetails.passport ?? "");
// 		}
// 		if (profileData?.partnerDetails?.preferWorkingLocation?.length > 0) {
// 			const selectedLocations = workingLocationOptions.filter((loc) =>
// 				profileData.partnerDetails.preferWorkingLocation.includes(loc.id.toString())
// 			);
// 			setWorkingLocation(selectedLocations);
// 		}
// 		if (profileData?.partnerDetails?.complexion) {
// 			setComplexion(profileData?.partnerDetails?.complexion || profileData?.partnerDetails?.complexion == 0 ? `${profileData?.partnerDetails?.complexion}` : null)

// 		}

// 		if (profileData?.partnerDetails?.preferProfession?.length > 0) {
// 			const selectedProfessions = professions.filter((p) =>
// 				profileData.partnerDetails.preferProfession.includes(p.id.toString())
// 			);
// 			setSelectedProfession(selectedProfessions);
// 		}
// 		if (profileData?.partnerDetails?.preferEducation?.length > 0) {
// 			const selectedEducationOptions = educationList.filter((edu) =>
// 				profileData.partnerDetails.preferEducation.includes(edu.id.toString())
// 			);
// 			setSelectedEducation(selectedEducationOptions);
// 		}
// 		if (profileData?.partnerDetails?.preferCastes?.length > 0) {
// 			const selectedCasteOptions = castes.filter((caste) =>
// 				profileData.partnerDetails.preferCastes.includes(caste.id.toString())
// 			);
// 			setSelectedCaste(selectedCasteOptions);
// 		}
// 		if (profileData?.partnerDetails?.familyStatus) {
// 			const matchedStatus = familyStatusList.find(
// 				(item) => item.id === profileData.partnerDetails.familyStatus.id
// 			);
// 			setSelectedFamilyStatus(matchedStatus || null);
// 		}
// 		if (profileData?.partnerDetails?.ageFrom) {
// 			setAgeFrom(profileData.partnerDetails.ageFrom);
// 		}
// 		if (profileData?.partnerDetails?.ageTo) {
// 			setAgeTo(profileData.partnerDetails.ageTo);
// 		}
// 		if (profileData?.partnerDetails?.readyForInterCasteMarriage !== undefined) {
// 			setInterCasteMarriage(profileData.partnerDetails.readyForInterCasteMarriage);
// 		}

// 		if (profileData?.partnerDetails?.anualIncomeFrom !== undefined) {
// 			setAnualIncomeFrom(profileData.partnerDetails.anualIncomeFrom);
// 		}
// 		if (profileData?.partnerDetails?.smoke !== undefined) {
// 			setSmoke(profileData.partnerDetails.smoke);
// 		}
// 		if (profileData && profileData?.partnerDetails) {
// 			const { drink, complexion } = profileData.partnerDetails;

// 			if (drink !== undefined && drink !== null) setDrink(drink.toString());
// 			// if (complexion !== undefined && complexion !== null) setComplexion(profileData?.partnerDetails?.complexion);
// 		}
// 		if (profileData?.partnerDetails) {
// 			setConvertedCaste(profileData.partnerDetails.lookingForSameConvertedCast ?? "");
// 			setKujaDosham(profileData.partnerDetails.khujaDhosham ?? "");
// 		}
// 	}, [profileData, heightOptions, workingLocationOptions, professions, educationList, castes, familyStatusList, type]);

// 	return (
// 		<Container maxWidth={false} sx={{ maxWidth: "none" }}>
// 			{type != "edit" && <Box
// 				sx={{
// 					display: "flex",
// 					justifyContent: "space-between",
// 					alignItems: "center",
// 					flexDirection: { xs: "column", md: "row" },
// 					px: { xs: 0, sm: 25 },
// 					py: { xs: 2 }
// 				}}
// 			>
// 				<Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
// 					<img
// 						src="/images/Frame 148.png"
// 						alt="Logo"
// 						style={{
// 							maxWidth: "330px",
// 							width: "100%",
// 							height: "auto",
// 						}}
// 					/>
// 				</Box>

// 				<Box
// 					sx={{
// 						position: "relative",
// 						width: 180,
// 						height: 180,
// 						display: "flex",
// 						justifyContent: "center",
// 						alignItems: "center",
// 					}}
// 				>
// 					<CircularProgress
// 						variant="determinate"
// 						value={100}
// 						size={120}
// 						thickness={3}
// 						sx={{
// 							position: "absolute",
// 							color: "#F0E0D0",
// 						}}
// 					/>
// 					<CircularProgress
// 						variant="determinate"
// 						value={20}
// 						size={120}
// 						thickness={3}
// 						sx={{
// 							position: "absolute",
// 							color: "#B56E2C",
// 						}}
// 					/>
// 					<Box sx={{ textAlign: "center" }}>
// 						<Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>80%</Typography>
// 						<Typography sx={{ color: "#B56E2C" }}>completed</Typography>
// 					</Box>
// 				</Box>
// 			</Box>}
// 			<FormContainer elevation={0} sx={{ ...styles.formCard }}>
// 				<DecorativeCorner
// 					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
// 				/>
// 				<DecorativeCorner
// 					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
// 				/>
// 				<DecorativeCorner
// 					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
// 				/>
// 				<DecorativeCorner
// 					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
// 				/>

// 				<div className="form-content">
// 					<Typography variant="h6" style={styles.formTitle}>
// 						Partner Preferences
// 					</Typography>
// 					<Grid container spacing={2}>
// 						<Grid item xs={12} sm={6} md={6}>
// 							<Autocomplete
// 								multiple
// 								options={maritalStatuses}
// 								getOptionLabel={(option) => option.name}
// 								value={selectedLookingFor}
// 								onChange={(event, newValue) => setSelectedLookingFor(newValue)}
// 								renderInput={(params) => (
// 									<StyledTextField
// 										{...params}
// 										label="Looking for"
// 										variant="outlined"
// 										size="small"
// 									/>
// 								)}
// 							/>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>
// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>No Caste Bar</InputLabel>
// 								<Select
// 									value={noCasteBar}
// 									onChange={(e) => setNoCasteBar(e.target.value)}
// 									label="No Caste Bar"
// 								>
// 									<MenuItem value="1">Yes</MenuItem>
// 									<MenuItem value="0">No</MenuItem>
// 									{/* <MenuItem value="3">Doesn't Matter</MenuItem> */}
// 								</Select>

// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							{noCasteBar == "0" &&
// 								<StyledFormControl fullWidth size="small">
// 									<InputLabel>Ready for Inter-caste Marriage</InputLabel>
// 									<Select
// 										value={interCasteMarriage}
// 										onChange={(e) => setInterCasteMarriage(e.target.value)}
// 										label="Ready for Inter-caste Marriage"
// 									>
// 										<MenuItem value="1">Yes</MenuItem>
// 										<MenuItem value="0">No</MenuItem>
// 										{/* <MenuItem value="2">Maybe</MenuItem> */}
// 									</Select>
// 								</StyledFormControl>
// 							}

// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							{(interCasteMarriage == "1" && noCasteBar == "0") &&
// 								<Autocomplete
// 									multiple
// 									options={castes}
// 									getOptionLabel={(option) => option.castName}
// 									value={selectedCaste}
// 									onChange={(event, newValue) => setSelectedCaste(newValue)}
// 									renderInput={(params) => (
// 										<StyledTextField
// 											{...params}
// 											label="Caste"
// 											variant="outlined"
// 											size="small"
// 										/>
// 									)}
// 								/>
// 							}
// 						</Grid>

// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Age From</InputLabel>
// 								<Select
// 									value={ageFrom}
// 									onChange={(e) => setAgeFrom(e.target.value)}
// 									label="Age From"
// 								>
// 									{[...Array(23)].map((_, i) => (
// 										<MenuItem key={i} value={18 + i}>
// 											{18 + i}
// 										</MenuItem>
// 									))}
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Age To</InputLabel>
// 								<Select
// 									value={ageTo}
// 									onChange={(e) => setAgeTo(e.target.value)}
// 									label="Age To"
// 								>
// 									{[...Array(33)].map((_, i) => (
// 										<MenuItem key={i} value={18 + i}>
// 											{18 + i}
// 										</MenuItem>
// 									))}
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>
// 							<StyledFormControl fullWidth size="small">


// 								<Autocomplete
// 									options={heightOptions}
// 									getOptionLabel={(option) => option.name}
// 									value={heightFrom}
// 									onChange={(e, newVal) => setHeightFrom(newVal)}
// 									renderInput={(params) => (
// 										<StyledTextField {...params} label="Height From" size="small" />
// 									)}
// 								/>

// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">

// 								<Autocomplete
// 									options={heightOptions}
// 									getOptionLabel={(option) => option.name}
// 									value={heightTo}
// 									onChange={(event, newValue) => setHeightTo(newValue)}
// 									renderInput={(params) => (
// 										<StyledTextField
// 											{...params}
// 											label="Height To"
// 											variant="outlined"
// 											size="small"
// 										/>
// 									)}
// 								/>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Family Status</InputLabel>
// 								<Select
// 									value={selectedFamilyStatus?.id || ""}
// 									onChange={handleFamilyStatusChange}
// 									label="Family Status"
// 								>
// 									{familyStatusList.map((status) => (
// 										<MenuItem key={status.id} value={status.id}>
// 											{status.name}
// 										</MenuItem>
// 									))}
// 								</Select>
// 							</StyledFormControl>
// 							</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Looking for same converted</InputLabel>
// 								<Select
// 									value={convertedCaste}
// 									onChange={(e) => setConvertedCaste(e.target.value)}
// 									label="Looking for same converted"
// 								>
// 									<MenuItem value="1">Yes</MenuItem>
// 									<MenuItem value="2">No</MenuItem>
// 									<MenuItem value="3">Doesn't Matter</MenuItem>
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Kuja Dosham</InputLabel>
// 								<Select
// 									value={kujaDosham}
// 									onChange={(e) => setKujaDosham(e.target.value)}
// 									label="Kuja Dosham"
// 								>
// 									<MenuItem value="1">Yes</MenuItem>
// 									<MenuItem value="0">No</MenuItem>
// 									<MenuItem value="2">Doesn't Matter</MenuItem>
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>


// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Complexion</InputLabel>
// 								<Select
// 									value={complexion}
// 									onChange={handleComplexionChange}
// 									label="Complexion"
// 								>
// 									<MenuItem value="1">Fair</MenuItem>
// 									<MenuItem value="2">Medium</MenuItem>
// 									<MenuItem value="3">Dark</MenuItem>
// 									<MenuItem value="4">Doesn't Matter</MenuItem>
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>
// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Smoke</InputLabel>
// 								<Select value={profileData?.partnerDetails?.smoke || smoke} onChange={handleSmokeChange} label="Smoke">
// 									<MenuItem value="1">Yes</MenuItem>
// 									<MenuItem value="0">No</MenuItem>
// 									<MenuItem value="2">Occasionally</MenuItem>
// 									<MenuItem value="3">Doesn't Matter</MenuItem>
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Drink</InputLabel>
// 								<Select value={profileData?.partnerDetails?.drink || drink} onChange={handleDrinkChange} label="Drink">
// 									<MenuItem value="1">Yes</MenuItem>
// 									<MenuItem value="0">No</MenuItem>
// 									<MenuItem value="2">Occasionally</MenuItem>
// 									<MenuItem value="3">Doesn't Matter</MenuItem>
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<Autocomplete
// 								multiple
// 								options={educationList}
// 								getOptionLabel={(option) => option.educationName}
// 								value={selectedEducation}
// 								onChange={(event, newValue) => setSelectedEducation(newValue)}
// 								renderInput={(params) => (
// 									<StyledTextField
// 										{...params}
// 										label="Education"
// 										variant="outlined"
// 										size="small"
// 									/>
// 								)}
// 							/>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<Autocomplete
// 								multiple
// 								options={professions}
// 								getOptionLabel={(option) => option.professionName}
// 								value={selectedProfession}
// 								onChange={(event, newValue) => setSelectedProfession(newValue)}
// 								renderInput={(params) => (
// 									<StyledTextField
// 										{...params}
// 										label="Profession"
// 										variant="outlined"
// 										size="small"
// 									/>
// 								)}
// 							/>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<Autocomplete
// 								multiple
// 								options={workingLocationOptions}
// 								getOptionLabel={(option) => option.name}
// 								value={workingLocation}
// 								onChange={(event, newValue) => setWorkingLocation(newValue)}
// 								renderInput={(params) => (
// 									<StyledTextField
// 										{...params}
// 										label="Working Location"
// 										variant="outlined"
// 										size="small"
// 									/>
// 								)}
// 							/>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							{/* <StyledFormControl fullWidth size="small">
// 													<InputLabel>Working Location</InputLabel>

// 							<Select
// 							multiple
// 							value={workingLocation}
// 							onChange={handleWorkingLocationChange}
// 							label="Working Location"
// 							renderValue={(selected) =>
// 								selected
// 								.map((val) =>
// 									val === "1" ? "India" :
// 									val === "2" ? "Abroad" :
// 									val === "3" ? "Doesn't Matter" : ""
// 								)
// 								.join(", ")
// 							}
// 							>
// 							<MenuItem value="1">India</MenuItem>
// 							<MenuItem value="2">Abroad</MenuItem>
// 							<MenuItem value="3">Doesn't Matter</MenuItem>
// 							</Select>
// 							</StyledFormControl> */}

// 							<StyledFormControl fullWidth size="small">
// 								<InputLabel>Passport</InputLabel>
// 								<Select
// 									value={passport}
// 									onChange={handlePassportChange}
// 									label="Passport"
// 								>
// 									<MenuItem value={1}>Yes</MenuItem>
// 									<MenuItem value={0}>No</MenuItem>
// 									<MenuItem value={2}>Doesn't Matter</MenuItem>
// 								</Select>
// 							</StyledFormControl>
// 						</Grid>
// 						<Grid item xs={12} sm={6} md={6}>

// 							<StyledTextField
// 								fullWidth
// 								label="Anual Income"
// 								type="number"
// 								value={anualIncomeFrom}
// 								onChange={(e) => setAnualIncomeFrom(e.target.value)}
// 								size="small"
// 							/>

// 						</Grid>
// 					</Grid>

// 					<StyledButton
// 						variant="contained"
// 						onClick={handleContinue}
// 						sx={{
// 							width: { xs: "100%", sm: "160px" },
// 							marginTop: { xs: 3, md: 4 },
// 							padding: "15px 0px",
// 						}}
// 					>
// 						Complete Profile
// 					</StyledButton>
// 				</div>
// 			</FormContainer>

// 			<CustomAlert
// 				open={alert.open}
// 				message={alert.message}
// 				severity={alert.severity}
// 				onClose={() => setAlert({ ...alert, open: false })}
// 			/>
// 		</Container>
// 	);
// };

// export default PartnerPreferencesForm;

import React, { useState, useEffect } from "react";
import { Box, Typography, Container, Autocomplete, CircularProgress, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import {
	StyledFormControl,
	FormContainer,
	StyledButton,
	FormGrid,
	StyledTextField,
} from "../../common/FormStyles";
import { InputLabel, MenuItem, Select } from "@mui/material";
import {
	getLookingForList,
	getReligionsList,
	getCastesList,
	getEducationList,
	getProfessionList,
	updatePartnerDetails,
	getFamilyStatusList,
	getProfileDetails,
} from "../../../services/operations/userOperations";
import CustomAlert from "../../common/CustomAlert";
import { calculateAge } from "./common-methods";
 export  const  heightOptions = [
	{ id: 137, name: `4'6" (137 cm)` },
	{ id: 140, name: `4'7" (140 cm)` },
	{ id: 142, name: `4'8" (142 cm)` },
	{ id: 145, name: `4'9" (145 cm)` },
	{ id: 147, name: `4'10" (147 cm)` },
	{ id: 150, name: `4'11" (150 cm)` },
	{ id: 152, name: `5'0" (152 cm)` },
	{ id: 155, name: `5'1" (155 cm)` },
	{ id: 157, name: `5'2" (157 cm)` },
	{ id: 160, name: `5'3" (160 cm)` },
	{ id: 163, name: `5'4" (163 cm)` },
	{ id: 165, name: `5'5" (165 cm)` },
	{ id: 168, name: `5'6" (168 cm)` },
	{ id: 170, name: `5'7" (170 cm)` },
	{ id: 173, name: `5'8" (173 cm)` },
	{ id: 175, name: `5'9" (175 cm)` },
	{ id: 178, name: `5'10" (178 cm)` },
	{ id: 180, name: `5'11" (180 cm)` },
	{ id: 183, name: `6'0" (183 cm)` },
	{ id: 185, name: `6'1" (185 cm)` },
	{ id: 188, name: `6'2" (188 cm)` },
	{ id: 191, name: `6'3" (191 cm)` },
	{ id: 193, name: `6'4" (193 cm)` },
	{ id: 196, name: `6'5" (196 cm)` },
	{ id: 198, name: `6'6" (198 cm)` },
	{ id: 201, name: `6'7" (201 cm)` },
	{ id: 203, name: `6'8" (203 cm)` },
	{ id: 206, name: `6'9" (206 cm)` },
	{ id: 208, name: `6'10" (208 cm)` },
];
const maritalStatuses = [
	{ id: "Single", name: "Un Married" },
	// { id: "Married", name: "Married" },
	{ id: "Divorced", name: "Divorced" },
	{ id: "WaitingForDivorce", name: "Waiting for Divorce" },
	{ id: "Widowed", name: "Widowed" },
];
const CasteBar = [
	{ id: 1, name: "Yes" },
	{ id: 0, name: "No" },

];
const khujaDhosamlist = [
	{ id: 1, name: "Yes" },
	{ id: 2, name: "No" },
	{ id: 3, name: "Doesn't Matter" }
]
const somecoverted = [
	{ id: 1, name: "Yes" },
	{ id: 2, name: "No" },
	{ id: 3, name: "Doesn't Matter" }
]
const complexionlist = [
	{ id: 1, name: "Fair" },
	{ id: 2, name: "Medium" },
	{ id: 3, name: "Dark" },
	{ id: 4, name: "Doesn't Matter" },

]

const smokelist = [
	{ id: 1, name: "Yes" },
	{ id: 2, name: "No" },
	{ id: 3, name: "Occasionally" },
	{ id: 4, name: "Doesn't Matter" },

]
const drinklist = [
	{ id: 1, name: "Yes" },
	{ id: 2, name: "No" },
	{ id: 3, name: "Occasionally" },
	{ id: 4, name: "Doesn't Matter" },

]
export const ageOptions = [...Array(25)].map((_, i) => ({
	id: 18 + i,
	name: String(18 + i),
}));
const agetoOptions=[...Array(33)].map((_,i)=>({
	id: 18 + i,
	name: String(18 + i),
}))
const passportlist = [
	{ id: 1, name: "Yes" },
	{ id: 2, name: "No" },
	{ id: 3, name: "Doesn't Matter" }
]
const workingLocationOptions = [{ id: 1, name: "India" }, { id: 2, name: "Abroad" }, { id: 3, name: "Doesn't Matter" }]
const PartnerPreferencesForm = (props) => {
	let { type,onSubmitSuccess } = props
	const navigate = useNavigate();
	const [lookingForList, setLookingForList] = useState([]);
	// const [selectedLookingFor, setSelectedLookingFor] = useState(null);
	const [religions, setReligions] = useState([]);
	// const [selectedReligion, setSelectedReligion] = useState(null);
	const [castes, setCastes] = useState([]);
	const [selectedCaste, setSelectedCaste] = useState([]);
	const [selectedLookingFor, setSelectedLookingFor] = useState([])
	const [educationList, setEducationList] = useState([]);
	const [selectedEducation, setSelectedEducation] = useState([]);
	const [professions, setProfessions] = useState([]);
	const [selectedProfession, setSelectedProfession] = useState([]);

	const [alert, setAlert] = useState({
		open: false,
		message: "",
		severity: "success",
	});

	const [selectedFamilyStatus, setSelectedFamilyStatus] = useState("");
	const [familyStatusList, setFamilyStatusList] = useState([]);
	const [ageFrom, setAgeFrom] = useState(null);
	const [anualIncomeFrom, setAnualIncomeFrom] = useState("");
	const [ageTo, setAgeTo] = useState("");
	const [heightFrom, setHeightFrom] = useState(null);
	const [heightTo, setHeightTo] = useState(null);
	const [interCasteMarriage, setInterCasteMarriage] = useState("");
	const [convertedCaste, setConvertedCaste] = useState(null);
	const [noCasteBar, setNoCasteBar] = useState(null);
	const [kujaDosham, setKujaDosham] = useState(null);
	const [complexion, setComplexion] = useState(null);
	const [smoke, setSmoke] = useState(null);
	const [drink, setDrink] = useState(null);
	const [workingLocation, setWorkingLocation] = useState([]);
	const [passport, setPassport] = useState(null);
	let userType = sessionStorage.getItem("userType")
	let token
	if (userType) {
		token = sessionStorage.getItem("token");
	} else {
		token = localStorage.getItem("token");
	}
	// Add mapping for complexion values
	const COMPLEXION_MAP = {
		fair: 1,
		medium: 2,
		dark: 3,
		doesnt_matter: 4,
	};

	const [profileData, setProfileData] = useState(null);
	useEffect(() => {
		const fetchProfile = async () => {
			try {
				const response = await getProfileDetails();
				if (response.status) {
					setProfileData(response.data);
				}
			} catch (error) {
				console.error("Error fetching profile details:", error);
			}
		};

		fetchProfile();
	}, [type]);
	useEffect(() => {
		const fetchLookingFor = async () => {
			try {
				const response = await getLookingForList();
				if (response.status) {
					setLookingForList(response.data);
				}
			} catch (error) {
				console.error("Error fetching looking for list:", error);
			}
		};

		const fetchReligions = async () => {
			try {
				const response = await getReligionsList();
				if (response.status) {
					setReligions(response.data);
				}
			} catch (error) {
				console.error("Error fetching religions:", error);
			}
		};

		const fetchCastes = async () => {
			try {
				const response = await getCastesList();
				if (response.status) {
					setCastes(response.data);
				}
			} catch (error) {
				console.error("Error fetching castes:", error);
			}
		};

		const fetchEducation = async () => {
			try {
				const response = await getEducationList();
				if (response.status) {
					setEducationList(response.data);
				}
			} catch (error) {
				console.error("Error fetching education list:", error);
			}
		};

		const fetchProfessions = async () => {
			try {
				const response = await getProfessionList();
				if (response.status) {
					setProfessions(response.data);
				}
			} catch (error) {
				console.error("Error fetching professions:", error);
			}
		};

		const fetchFamilyStatusList = async () => {
			try {
				const response = await getFamilyStatusList();
				if (response.status) {
					setFamilyStatusList(response.data);
				}
			} catch (error) {
				console.error("Error fetching family status list:", error);
			}
		};

		if (token) {
			fetchLookingFor();
			fetchReligions();
			fetchCastes();
			fetchEducation();
			fetchProfessions();
			fetchFamilyStatusList();
		}
	}, []);
	const [ageOptionsFrom,setAgeOptionsFrom] = useState([ageOptions])
	const [ageOptionsTo,setAgeOptionsTo] = useState([])
	const [customerAge,setCustomerAge] = useState()
	useEffect(() => {
		const fetchAndPopulateData = async () => {
			try {
				const response = await getProfileDetails();
				if (response.status && response.data?.partnerDetails) {
					const data = response.data.partnerDetails;

					// Basic preferences
					// setSelectedLookingFor(
					// 	lookingForList.find((l) => l.id === data.lookingFor) || null
					// );
					setSelectedFamilyStatus(
						familyStatusList.find((fs) => fs.id === data?.familyStatus) || null
					);
					setInterCasteMarriage(data?.readyForInterCasteMarriage || data?.readyForInterCasteMarriage == 0 ? `${data?.readyForInterCasteMarriage}` : null)
					setConvertedCaste(
						data?.lookingForSameConvertedCast || data?.lookingForSameConvertedCast == 0 ? `${data?.lookingForSameConvertedCast}` : null
					);
					// Age and height preferences
					setAgeFrom(data?.ageFrom?.toString() || "");
					setAgeTo(data?.ageTo?.toString() || "");
					// setHeightFrom(data.heightFrom?.toString() || "");
					// setHeightTo(data.heightTo?.toString() || "");

					// Religion and caste preferences
					// setSelectedReligion(
					// 	religions.find((r) => r.id === data.religion) || null
					// );
					if (data?.preferCastes) {
						const skillIds =
							typeof data?.preferCastes === "string"
								? data?.preferCastes.split(",").map(Number)
								: Array.isArray(data?.preferCastes)
									? data?.preferCastes
									: [];

						// Find matching skills from SKILLS_LIST
						const selectedSkills = castes.filter((cast) =>
							skillIds.includes(cast.id)
						);

						setSelectedCaste(selectedSkills);
					}
					// setSelectedCaste(
					// 	[castes.find((c) => c.id === data.caste)].filter(Boolean)
					// );

					// Marriage preferences
					// setInterCasteMarriage(
					// 	data.readyForInterCasteMarriage === 1 ? "yes" : "no"
					// );
					// setConvertedCaste(
					// 	data.lookingForSameConvertedCast === 1 ? "yes" : "no"
					// );
					// Lifestyle preferences

					setKujaDosham(data?.khujaDhosham || data?.khujaDhosham == 0 ? `${data?.khujaDhosham}` : null)
					// setComplexion(
					// 	Object.keys(COMPLEXION_MAP).find(
					// 		(key) => COMPLEXION_MAP[key] === data.complexion
					// 	) || ""
					// );
					setSmoke(data?.smoke || data?.smoke == 0 ? `${data?.smoke}` : null);
					setDrink(data?.drink || data?.drink == 0 ? `${data?.drink}` : null);
					setWorkingLocation(data?.workingLocation || data?.workingLocation == 0 ? `${data?.workingLocation}` : null)
					// Education and profession

					if (data?.preferEducation) {
						const educatonIds =
							typeof data?.preferEducation === "string"
								? data?.preferEducation.split(",").map(Number)
								: Array.isArray(data?.preferEducation)
									? data?.preferEducation
									: [];

						// Find matching skills from SKILLS_LIST
						const education = educationList.filter((cast) =>
							educatonIds.includes(cast.id)
						);

						setSelectedEducation(education);
					}

					if (data.preferProfession) {
						const professionIds =
							typeof data?.preferProfession === "string"
								? data?.preferProfession.split(",").map(Number)
								: Array.isArray(data?.preferProfession)
									? data?.preferProfession
									: [];

						// Find matching skills from SKILLS_LIST
						const newPro = professions.filter((cast) =>
							professionIds.includes(cast.id)
						);

						setSelectedProfession(newPro);
					}
					// setSelectedEducation(
					// 	[educationList.find((e) => e.id === data.education)].filter(Boolean)
					// );
					// setSelectedProfession(
					// 	[professions.find((p) => p.id === data.profession)].filter(Boolean)
					// );

					// Other preferences
					setPassport(data?.passport || data?.passport == 0 ? `${data?.passport}` : null);
				}
			} catch (error) {
				console.error("Error fetching profile data:", error);
			}
		};

		if (
			token &&
			lookingForList.length &&
			religions.length &&
			castes.length
		) {
			fetchAndPopulateData();
		}
	}, [lookingForList, religions, castes, educationList, professions, type]);

	const handleContinue = async () => {
		try {
			console.log("no caste bar", noCasteBar);
			let newPayload = {
				"ageFrom": Number(ageFrom?.id) || null,
				"ageTo": Number(ageTo?.id) || null,
				"heightFrom": heightFrom ? Number(heightFrom?.id) : null,
				"heightTo": heightTo ? Number(heightTo?.id) : null,
				"familyStatus_id": Number(selectedFamilyStatus?.id) || null,
				"readyForInterCasteMarriage": Number(interCasteMarriage) || null,
				"preferCastes": selectedCaste ? selectedCaste.map((each) => each.id) : null,
				"complexion": complexion ? Number(complexion?.id) : null,
				"smoke": Number(smoke?.id) || null,
				"drink": Number(drink?.id),
				"preferEducation": selectedEducation ? selectedEducation.map((each) => each.id) : null,
				"preferProfession": selectedProfession ? selectedProfession.map((each) => each.id) : null,
				"passport": Number(passport?.id) || null,
				"preferWorkingLocation": workingLocation ? workingLocation.map((each) => each.id) : null,
				// "religion" : selectedReligion ? selectedReligion?.id : null,
				"anualIncomeFrom": anualIncomeFrom ? Number(anualIncomeFrom) : 0,
				lookingFor: selectedLookingFor ? selectedLookingFor.map((each) => each.name) : null,
				noCasteBar: noCasteBar ? Number(noCasteBar?.id) : null,
				// "khujaDhosham": kujaDosham !== undefined && kujaDosham !== null ? Number(kujaDosham) : null,
				"lookingForSameConvertedCast": Number(convertedCaste?.id) || null,
				"khujaDhosham": Number(kujaDosham?.id) || null,
			}

			const response = await updatePartnerDetails(newPayload);

			if (!response.status) {
				setAlert({
					open: true,
					message: response.message,
					severity: "error",
				});
				return;
			}

			setAlert({
				open: true,
				message: "Partner preferences updated successfully",
				severity: "success",
			});
			if (type != "edit") {
				setTimeout(() => {
					navigate("/profile/review");
				}, 1000);
			}else{
				onSubmitSuccess?.();
			}

		} catch (error) {
			setAlert({
				open: true,
				message: error.message || "Failed to update partner preferences",
				severity: "error",
			});
		}
	};

	const handleFamilyStatusChange = (event) => {
		// Get the selected family status object from the list
		const selectedStatus = familyStatusList.find(
			(status) => status.id === event.target.value
		);
		setSelectedFamilyStatus(selectedStatus);
	};

	const handleInterCasteMarriageChange = (event) => {
		setInterCasteMarriage(event.target.value);
	};

	const handleConvertedCasteChange = (event) => {
		setConvertedCaste(event.target.value);
	};

	const handleKujaDoshamChange = (event) => {
		setKujaDosham(event.target.value);
	};

	// const handleComplexionChange = (event) => {
	// 	setComplexion(event.target.value);
	// };
	const handleComplexionChange = (newValue) => {
		setComplexion(newValue);
	};

	const handleSmokeChange = (newValue) => {
		setSmoke(newValue);
	};

	const handleDrinkChange = (newValue) => {
		setDrink(newValue);
	};

	const handleWorkingLocationChange = (event) => {
		setWorkingLocation(event.target.value);
	};

	const handlePassportChange = (newValue) => {
		setPassport(newValue);
	};
	const [heightOptionsFrom,setHeightOptionsFrom] = useState([heightOptions])
	const [heightOptionsTo,setHeightOptionsTo] = useState([])

	useEffect(() => {
	const getProfileData = async() =>{
		if (profileData?.partnerDetails) {
			const selectedHeightFrom = heightOptions.find(
				(item) => item.id === profileData.partnerDetails.heightFrom
			);
			const selectedHeightTo = heightOptions.find(
				(item) => item.id === profileData.partnerDetails.heightTo
			);
			

			setHeightFrom(selectedHeightFrom || null);
			setHeightTo(selectedHeightTo || null);
		}
		if (profileData?.partnerDetails?.lookingFor && profileData?.partnerDetails?.lookingFor.length > 0) {
			const selectedCasteFor = maritalStatuses.filter((look) =>
				profileData?.partnerDetails?.lookingFor.includes(look.name.toString())
			);
			setSelectedLookingFor(selectedCasteFor);
		}

		if (profileData?.partnerDetails) {
			setPassport(passportlist.find((p) => p.id == profileData.partnerDetails.passport ?? ""));
		}
		if (profileData?.partnerDetails?.preferWorkingLocation?.length > 0) {
			const selectedLocations = workingLocationOptions.filter((loc) =>
				profileData.partnerDetails.preferWorkingLocation.includes(loc.id.toString())
			);
			setWorkingLocation(selectedLocations);
		}
		if (profileData?.partnerDetails?.complexion) {
			setComplexion(complexionlist.find((each) => each.id == profileData?.partnerDetails?.complexion || profileData?.partnerDetails?.complexion == 0 ? `${profileData?.partnerDetails?.complexion}` : null))

		}
		if (profileData?.partnerDetails?.preferProfession?.length > 0) {
			const selectedProfessions = professions.filter((p) =>
				profileData.partnerDetails.preferProfession.includes(p.id.toString())
			);
			setSelectedProfession(selectedProfessions);
		}
		if (profileData?.partnerDetails?.preferEducation?.length > 0) {
			const selectedEducationOptions = educationList.filter((edu) =>
				profileData.partnerDetails.preferEducation.includes(edu.id.toString())
			);
			setSelectedEducation(selectedEducationOptions);
		}
		if (profileData?.partnerDetails?.preferCastes?.length > 0) {
			const selectedCasteOptions = castes.filter((caste) =>
				profileData.partnerDetails.preferCastes.includes(caste.id.toString())
			);
			setSelectedCaste(selectedCasteOptions);
		}
		if (profileData?.partnerDetails?.familyStatus) {
			const matchedStatus = familyStatusList.find(
				(item) => item.id === profileData.partnerDetails.familyStatus.id
			);
			setSelectedFamilyStatus(matchedStatus || null);
		}
		if (profileData?.partnerDetails?.ageFrom) {
			setAgeFrom(ageOptions.find((a) => a.id == profileData.partnerDetails.ageFrom));
		}
		if (profileData?.partnerDetails?.ageTo) {
			setAgeTo(agetoOptions.find((a)=>a.id == profileData.partnerDetails.ageTo));
		}
		if (profileData?.partnerDetails?.readyForInterCasteMarriage !== undefined) {
			setInterCasteMarriage(profileData.partnerDetails.readyForInterCasteMarriage);
		}

		if (profileData?.partnerDetails?.anualIncomeFrom !== undefined) {
			setAnualIncomeFrom(profileData.partnerDetails.anualIncomeFrom);
		}
		if (profileData?.partnerDetails?.smoke !== undefined) {
			setSmoke(smokelist.find((each) => each.id == profileData.partnerDetails.smoke));
		}
		if (profileData && profileData?.partnerDetails) {
			setDrink(drinklist.find((d) => d.id == profileData.partnerDetails.drink))
			// const { drink, complexion } = profileData.partnerDetails;

			// if (drink !== undefined && drink !== null) setDrink(drink.toString());
			// if (complexion !== undefined && complexion !== null) setComplexion(profileData?.partnerDetails?.complexion);
		}
		if (profileData?.partnerDetails?.noCastBar || profileData?.partnerDetails?.noCastBar == 0) {
			setNoCasteBar(CasteBar.find((each) => each.id == profileData.partnerDetails.noCastBar));
		}
		if (profileData?.partnerDetails) {
			setConvertedCaste(somecoverted.find((each) => each.id == profileData.partnerDetails.lookingForSameConvertedCast ?? ""));
			setKujaDosham(khujaDhosamlist.find((each) => each.id == profileData.partnerDetails.khujaDhosham ?? ""));
		}
		if(profileData?.customerPersonalDetails.height){
				if(profileData?.gender == "Female"){
					let filteredFromOptions = await heightOptions.filter(option => option.id >= profileData.customerPersonalDetails.height);
					setHeightOptionsFrom(filteredFromOptions)
				}else{
					let filteredFromOptions = await heightOptions.filter(option => option.id <= profileData.customerPersonalDetails.height);
					setHeightOptionsFrom(filteredFromOptions)
				}
			}
		if(profileData?.customerPersonalDetails.dateOfBirth){
			const age = await calculateAge(profileData.customerPersonalDetails.dateOfBirth)
			setCustomerAge(age)
			if(profileData?.gender == "Female"){
				let filteredFromOptions = await ageOptions.filter(option => option.id >= age);
				setAgeOptionsFrom(filteredFromOptions)
			}else{
				let filteredFromOptions = await ageOptions.filter(option => option.id <= age);
				setAgeOptionsFrom(filteredFromOptions)
			}
		}
	}
	getProfileData()

	}, [profileData, heightOptions, workingLocationOptions, professions, educationList, castes, familyStatusList, type]);

	return (
		<Container maxWidth={false} sx={{ maxWidth: "none" }}>
			{type != "edit" && <Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexDirection: { xs: "column", md: "row" },
					px: { xs: 0, sm: 25 },
					py: { xs: 2 }
				}}
			>
				<Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
					<img
						src="/images/Frame 148.png"
						alt="Logo"
						style={{
							maxWidth: "330px",
							width: "100%",
							height: "auto",
						}}
					/>
				</Box>

				<Box
					sx={{
						position: "relative",
						width: 180,
						height: 180,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						variant="determinate"
						value={100}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#F0E0D0",
						}}
					/>
					<CircularProgress
						variant="determinate"
						value={profileData?.profileStrength}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#B56E2C",
						}}
					/>
					<Box sx={{ textAlign: "center" }}>
						<Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>{profileData?.profileStrength}</Typography>
						<Typography sx={{ color: "#B56E2C" }}>completed</Typography>
					</Box>
				</Box>
			</Box>}
			<FormContainer elevation={0} sx={{ ...styles.formCard }}>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>

				<div className="form-content">
				
					<div style={{display:"flex",justifyContent:"space-between"}}>
						<Typography variant="h6" style={styles.formTitle}>
							Partner Preferences
						</Typography>
						{(type != "edit" && profileData?.profileStrength >= 65) && <Button
						variant="outlined"
						color="secondary"
						sx={{ ...styles.skipButton }}
						onClick={() => {
							window.location.href = "/profile/DetaliesDashbord?type=suggested-profiles";
						}}
	
	
						>
						Skip
						</Button> }
						</div>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								multiple
								options={maritalStatuses}
								getOptionLabel={(option) => option.name}
								value={selectedLookingFor}
								onChange={(event, newValue) => setSelectedLookingFor(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Looking for (1)"
										variant="outlined"
										size="small"
									/>
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={6}>

							<Autocomplete
								options={CasteBar} getOptionLabel={(option) => option.name}
								value={noCasteBar}
								onChange={(event, newValue) => setNoCasteBar(newValue)}
								renderInput={(params) => (
									<StyledTextField {...params} label="No Caste Bar" size="small" />
								)}
							/>
						</Grid>

						<Grid item xs={12} sm={6} md={6}>

							{noCasteBar == "0" &&
								<StyledFormControl fullWidth size="small">
									<InputLabel>Ready for Inter-caste Marriage</InputLabel>
									<Select
										value={interCasteMarriage}
										onChange={(e) => setInterCasteMarriage(e.target.value)}
										label="Ready for Inter-caste Marriage"
									>
										<MenuItem value="1">Yes</MenuItem>
										<MenuItem value="0">No</MenuItem>
										{/* <MenuItem value="2">Maybe</MenuItem> */}
									</Select>
								</StyledFormControl>
							}

						</Grid>
						<Grid item xs={12} sm={6} md={6}>

							{(interCasteMarriage == "1" && noCasteBar == "0") &&
								<Autocomplete
									multiple
									options={castes}
									getOptionLabel={(option) => option.castName}
									value={selectedCaste}
									onChange={(event, newValue) => setSelectedCaste(newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Caste"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							}
						</Grid>

						<Grid item xs={12} sm={6} md={6}>

							<StyledFormControl fullWidth size="small">

								<StyledFormControl fullWidth size="small">
									<Autocomplete
										options={ageOptionsFrom}
										getOptionLabel={(option) => option?.name || ""}
										value={ageFrom || null}
										onChange={(e, newValue) =>{ 
											let filteredToOptions = ageOptions.filter(option => option.id >= newValue?.id);
											setAgeOptionsTo(filteredToOptions)
											setAgeFrom(newValue)
											setAgeTo(null)
										}
										}
										renderInput={(params) => (
											<StyledTextField {...params} label="Age From (1)" size="small" />
										)}
									/>
								</StyledFormControl>

							</StyledFormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>

							<StyledFormControl fullWidth size="small">
								{/* <InputLabel>Age To</InputLabel>
								<Select
									value={ageTo}
									onChange={(e) => setAgeTo(e.target.value)}
									label="Age To"
								>
									{[...Array(33)].map((_, i) => (
										<MenuItem key={i} value={18 + i}>
											{18 + i}
										</MenuItem>
									))}
								</Select> */}
									<Autocomplete
										options={ageOptionsTo}
										getOptionLabel={(option) => option?.name || ""}
										value={ageTo || null}
										onChange={(e, newValue) => setAgeTo(newValue)}
										renderInput={(params) => (
											<StyledTextField {...params} label="Age To (1)" size="small" />
										)}
									/>
							</StyledFormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<StyledFormControl fullWidth size="small">
								<Autocomplete
									options={heightOptionsFrom}
									getOptionLabel={(option) => option.name}
									value={heightFrom}
									onChange={(e, newVal) =>{ 
										let filteredToOptions = heightOptions.filter(option => option.id >= newVal?.id);
										setHeightOptionsTo(filteredToOptions)
										setHeightTo(null)
										setHeightFrom(newVal)
									}}
									renderInput={(params) => (
										<StyledTextField {...params} label="Height From (1)" size="small" />
									)}
								/>

							</StyledFormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>

							<StyledFormControl fullWidth size="small">

								<Autocomplete
									options={heightOptionsTo}
									getOptionLabel={(option) => option.name}
									value={heightTo}
									onChange={(event, newValue) => setHeightTo(newValue)}
									renderInput={(params) => (
										<StyledTextField
											{...params}
											label="Height To (1)"
											variant="outlined"
											size="small"
										/>
									)}
								/>
							</StyledFormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={familyStatusList || []}
								getOptionLabel={(option) => option?.name || ""}
								value={selectedFamilyStatus || null}
								onChange={(event, newValue) => {
									setSelectedFamilyStatus(newValue);
								}}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Family Status"
										variant="outlined"
										size="small"
									/>
								)}
							/>

						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={somecoverted}
								getOptionLabel={(option) => option.name}
								value={convertedCaste}
								onChange={(event, newValue) => setConvertedCaste(newValue)}
								renderInput={(params) => (
									<StyledTextField {...params} label="Looking for same converted" size="small" />
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={khujaDhosamlist}
								getOptionLabel={(option) => option.name}
								value={kujaDosham}
								onChange={(event, newValue) => setKujaDosham(newValue)}
								renderInput={(params) => (
									<StyledTextField {...params}
										label="Kuja Dosham"
										size="small" />
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={complexionlist || []}
								getOptionLabel={(option) => option?.name || ""}
								value={complexion || null}
								onChange={(event, newValue) => handleComplexionChange(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Complexion"
										size="small"
									/>
								)}
							/>

						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={smokelist || []}
								getOptionLabel={(option) => option?.name || ""}
								value={smoke || null}
								onChange={(event, newValue) => handleSmokeChange(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="smoke "
										size="small"
									/>
								)}
							/>

						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={drinklist || []}
								getOptionLabel={(option) => option?.name || ""}
								value={drink || null}
								onChange={(event, newValue) => handleDrinkChange(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="drink "
										size="small"
									/>
								)}
							/>

						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								multiple
								options={educationList}
								getOptionLabel={(option) => option.educationName}
								value={selectedEducation}
								onChange={(event, newValue) => setSelectedEducation(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Education (1)"
										variant="outlined"
										size="small"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>

							<Autocomplete
								multiple
								options={professions}
								getOptionLabel={(option) => option.professionName}
								value={selectedProfession}
								onChange={(event, newValue) => setSelectedProfession(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Profession"
										variant="outlined"
										size="small"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>

							<Autocomplete
								multiple
								options={workingLocationOptions}
								getOptionLabel={(option) => option.name}
								value={workingLocation}
								onChange={(event, newValue) => setWorkingLocation(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Working Location"
										variant="outlined"
										size="small"
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={6}>
							<Autocomplete
								options={passportlist || []}
								getOptionLabel={(option) => option?.name || ""}
								value={passport || null}
								onChange={(event, newValue) => handlePassportChange(newValue)}
								renderInput={(params) => (
									<StyledTextField
										{...params}
										label="Passport"
										size="small"
									/>
								)}
							/>

						</Grid>
						<Grid item xs={12} sm={6} md={6}>

							<StyledTextField
								fullWidth
								label="Annual Income in Lakhs (1)"
								type="number"
								value={anualIncomeFrom}
								onChange={(e) => setAnualIncomeFrom(e.target.value)}
								size="small"
							/>

						</Grid>
					</Grid>

					<StyledButton
						variant="contained"
						onClick={handleContinue}
						sx={{
							width: { xs: "100%", sm: "160px" },
							marginTop: { xs: 3, md: 4 },
							padding: "15px 0px",
						}}
					>
						Complete Profile
					</StyledButton>
				</div>
			</FormContainer>

			<CustomAlert
				open={alert.open}
				message={alert.message}
				severity={alert.severity}
				onClose={() => setAlert({ ...alert, open: false })}
			/>
		</Container>
	);
};

export default PartnerPreferencesForm;
